
import "./loader.scss"

const Loader = ({ size }: { size?: string }) => {
    return <span className={`spinner-grow ${size}`}></span>;
}

export default Loader;